export const F2A_Biz = {
    UPDATE_PHONE: "update_phone",
    RESET_PASSWORD: "reset_password",
    ACCOUNT_RECOVERY: "account_recovery",
}